import { Mapper } from "../../../../base/utils/mapper";
import { RevisionModel } from "../../../../domain/models/configuration/revision.model";
import { RevisionEntity } from "../entities/revision.entity";

export class RevisionImplementationRepositoryMapper extends Mapper<RevisionEntity, RevisionModel> {
    mapFrom(param: RevisionEntity): RevisionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RevisionModel): RevisionEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}